<div class="ne-footer">
  <div class="ne-editor-nav">
    <!--
      it would be more flexible if this were a slot.
      at the time of this writing there was an issue
      with nested slots.
      https://v3.svelte.technology/tutorial/slots
    -->
    {#if isPhoto}
      <PhotoInput cover=false labelText={backText} />
    {/if}
    <span class="ne-right">
      <PrimaryButton
        isDisabled={canNotSaveEdits}
        trackingId='edit message save'
        data-test-id='nav-forward'
        buttonId='editor-footer-continue'
        click="{save}">
        {forwardText}
      </PrimaryButton>
    </span>
  </div>
</div>

<style>
  .ne-editor-nav {
    display: grid;
    -ms-grid-columns: 1fr 1fr;
    grid-template-columns: 1fr 1fr;
  }

  .ne-right {
    grid-column: 2;
    justify-self: end;
    display: inline-block;

    -ms-grid-column-justify: end;
    -ms-grid-column-align: end;
    -ms-grid-column-span: 2;
  }
</style>

<script>
  import PrimaryButton from './PrimaryButton.html';
  import PhotoInput from './PhotoInput.html';
  import { NOOP } from '../lib/constants';

  export let isPhoto = false;
  export let backText;
  export let forwardText;
  export let canNotSaveEdits = false;
  export let cancel = NOOP;
  export let save;
</script>
